import { account1 } from '../../services/bankAccountData';

// TODO: Validar los datos del formulario y los datos del evento

// TODO: Verificar si es de pago y devolver el HTML dependiendo el caso


const styles = {
    p: { border: "1px solid gray", width: "380px", backgroundColor: "#ddd" },
    divLogo: {
        textAlign: "center",
        width: "380px",
        margin: "10px 0px",
        backgroundColor: "#fff",
    },
    divLeftGrayWithBorder: {
        border: "1px solid gray",
        width: "380px",
        padding: "0 20px",
        margin: "10px 6px",
        backgroundColor: "#ddd",
    },
    divWhite: {
        textAlign: "center",
        width: "380px",
        margin: "10px 6px",
        backgroundColor: "#fff",
    },
    divWhiteNoMargin: {
        textAlign: "center",
        width: "380px",
        backgroundColor: "#fff",
    },
    divWhiteNoPadding: {
        textAlign: "center",
        width: "380px",
        margin: "10px 6px",
        backgroundColor: "#fff",
    },
    divWhiteLeft: {
        border: "1px solid gray",
        width: "380px",
        padding: "0 20px",
        margin: "10px 6px",
        backgroundColor: "#fff",
    },
    divWhiteLeftNoBorder: {
        width: "380px",
        padding: "10px 20px",
        margin: "10px 6px",
        backgroundColor: "#fff",
    },
    li: { padding: "6px 0" },
};


export const setEmailBodyRegistroGeneral = ({ values, eventData }) => {

    const { 
        partApellidoPaterno, 
        partApellidoMaterno, 
        partNombres, 
        partCorreo,
        partPais,
        partEstado,
        registroReferencia, 
        tipoRegistro, 
        tipoRegistroDocURL, 
        infoAdicional,
    } = values;
    const infoAdObj = JSON.parse(infoAdicional);
    const { registroConfirma, registroQR, registroDataQR } = infoAdObj;

    const { 
        urlLogo, tituloEvento, urlConfirmarRegistro 
    } = eventData;


    console.log({ values, infoAdObj, eventData });
    console.log({ values, eventData, registroConfirma, registroQR });

    const divDatosParaPago = (registroConfirma === 1)
        ? <div style={ styles.divWhiteLeft }>
            <h3>Indicaciones para completar el registro</h3>
            <ul>
                <li style={ styles.li }>
                    Pagar en sucursal bancaria la cuota correspondiente o,
                </li>
                <li>
                    Pagar por medio de su aplicación bancaria, en modalidad pago de servicios o,
                </li>
                <li>
                    Pagar directamente en caja del CIBNOR, horario de 9 a 14 horas en días hábiles.
                    <p>
                        Banco: <strong>{ account1.nombre }</strong><br />
                        Convenio CIE: <strong>{ account1.convenio }</strong> <br />
                        Referencia: <strong>{ registroReferencia }</strong><br />
                    </p>
                </li>
                <li style={ styles.li }>Subir al sistema su comprobante de deposito:<br/>
                    <h3><a href={ urlConfirmarRegistro }>Enlace para subir su comprobante</a></h3>
                </li>
                <li style={styles.li}>
                    <strong>Después de realizar el pago cuenta con un máximo de 5 días hábiles para completar su registro, en caso contrario este será anulado.</strong>
                </li>
                <li style={styles.li}>En caso de solicitar factura, ésta se enviará al correo que se ingresó.
                </li>
                <li style={styles.li}>Se realizará la facturación salvo buen cobro.
                </li>
            </ul>
            <p>
                Después de realizar el pago cuenta con un máximo de 5 días hábiles para completar su registro, en caso contrario este será anulado.
            </p>
        </div>
        : '';


    const linkDocProbatorio = (tipoRegistro !== 'Participante externo') 
        ? <a href={ tipoRegistroDocURL }>
            <strong>Consultar documento probatorio</strong>
        </a> 
        : '';


    return (
        <>
            {/* Logo */}
            <div style={ styles.divLogo }>
                <img src={ urlLogo } alt="logo" width={ 100 } />
            </div>
            {/* Titulo y numero de referencia */}
            <div style={ styles.divWhite }>
                <h3>¡Su registro inicial ha sido completado con éxito!</h3>
                <h2><i>{ tituloEvento }</i></h2>
                <h3>Numero de referencia:</h3>
                <h2>{ registroReferencia }</h2>
            </div>
            {/* Detalles personales */}
            <div style={styles.divWhiteLeft}>
                <p>
                    Nombre completo:<br /> 
                    <strong>
                        { partNombres } { partApellidoPaterno } { partApellidoMaterno }
                    </strong> <br /><br />
                    Correo: <br />
                    <strong>
                        { partCorreo }
                    </strong> <br /><br />
                    Procedencia: <br />
                    <strong>
                        { partEstado }, { partPais }
                    </strong> 
                </p>
                <p>
                    Tipo de inscripción: <br />
                    <strong>{ tipoRegistro }</strong> { linkDocProbatorio }<br /><br />
                    Numero de referencia asignado por el sistema: <br />
                    <strong>{ registroReferencia }</strong>
                </p>
            </div>

            {/* Datos para pago */}
            { divDatosParaPago }

            {/* Link a detalles y QR */}
            <div style={ styles.divWhiteLeftNoBorder }>
                <div dangerouslySetInnerHTML={{ 
                    __html: `Consulte los detalles de su registro en <a href=${ registroQR }>este enlace</a> o escaneando el QR al final de este mensaje.`
                }} />
                <div style={ styles.divWhite }>
                    <img src={ registroDataQR } alt="QR" width={ 200 } />
                </div>
            </div>
        </>
    )
}
